/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import type { Theme } from '@coursera/cds-core';

const styles = {
  card: (theme: Theme) => css`
    position: relative;
    padding: ${theme.spacing(24)};
    border: 1px solid ${theme.palette.gray[300]};
    margin-bottom: ${theme.spacing(16)};
    background-color: var(--cds-color-white-0);
    border-radius: 8px;

    ${theme.breakpoints.down('sm')} {
      padding: ${theme.spacing(24)};
      width: 100%;
    }
  `,
};

type PropsFromCaller = {
  // Using the css prop from emotion on a non-html React component overrides the css applied inside the component (see https://emotion.sh/docs/with-props).
  // I want to maintain the styles applied inside this component, so I created a this separate customCss prop.
  customCss?: Interpolation<Theme>;
  ['data-e2e']?: string;
};

type Props = PropsFromCaller & {
  children: React.ReactNode;
};

const ProfileViewerCard = ({ children, customCss, 'data-e2e': e2e }: Props) => {
  return (
    <section css={[styles.card, customCss]} data-e2e={e2e}>
      {children}
    </section>
  );
};

export default ProfileViewerCard;
